import React, { useEffect, useState } from 'react';
import './FloatingCta.css';

/**
 * Plávajúce CTA tlačidlo pre mobil – prilepené k spodnému okraju.
 * Skryje sa, keď je rezervačná sekcia viditeľná (nie je vtedy potrebné).
 */
export default function FloatingCta() {
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    const target = document.getElementById('rezervacia');
    if (!target || !('IntersectionObserver' in window)) return undefined;
    const observer = new IntersectionObserver(
      ([entry]) => setHidden(entry.isIntersecting),
      { rootMargin: '0px 0px -40% 0px' }
    );
    observer.observe(target);
    return () => observer.disconnect();
  }, []);

  return (
    <div className={`floating-cta ${hidden ? 'floating-cta--hidden' : ''}`}>
      <a href="#rezervacia" className="btn btn--primary">
        Over dostupnosť
      </a>
    </div>
  );
}
